<app-breadcrumb [master]="'Administracja'" [parentName]="'Słownik'" [name]="'Lista'"></app-breadcrumb>
<div class="tags-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <mat-form-field class="tags-list-filter">
      <mat-label>Nazwa tagu</mat-label>
      <input matInput  name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>


    <app-dict
      [multiple]="false" [dictType]="'dynamic_dictionary'"
      [label]="'Typ słownika'" class="tags-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

  </form>

  <div >


    <div class="tags-list-buttons">
      <button mat-raised-button (click)="downloadReport()" class="report-button">
        <mat-icon>download</mat-icon> <span>Pobierz raport</span>
      </button>

      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj</span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="dynamicDictionary"  >
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>  Nazwa Tagu</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['szczegoly', element.id]">{{element.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="typ">
      <th mat-header-cell *matHeaderCellDef > Typ tagu</th>
      <td mat-cell *matCellDef="let element" >
        {{element.type.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef  > Aktywny</th>
      <td mat-cell *matCellDef="let element" >
        {{ element.deleted ? 'TAK' : 'NIE' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!((userPermissions | async)?.dynamic_dictionary?.write)" mat-menu-item (click)="delete(element)">
            Usuń
          </button>
        </mat-menu>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
